var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNullCmd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    viewBox: "0 0 48 48",
    height: 36,
    width: 36,
    className: "createSvgIcon__Svg-sc-1l8xi8d-0 loXvaP ability-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 41.06c-.999-.905-2.241-2.18-3.608-3.78l-4.452 4.451v-2.955l3.175-3.042a66.463 66.463 0 0 1-2.177-2.887l-.057.019c-.86 1.074-3.224 3.044-4.299 3.895V32.06c.133-.134.266-.262.4-.39.544-.522 1.103-1.06 1.75-2.028l.077.038c-3.7-5.842-7.24-13.334-8.809-21.8l.653-.109C10.583 7.111 15.606 6.27 24 6.27c8.394 0 13.416.843 17.347 1.502h.001l.652.11C40.413 16.438 36.814 24 33.07 29.87l.467-.228c.646.969 1.206 1.506 1.749 2.027.134.13.267.258.4.39v4.702c-1.074-.85-3.438-2.82-4.298-3.895a3.098 3.098 0 0 0-.283-.08 66.76 66.76 0 0 1-2.02 2.696l.02.205 3.223 3.09v2.954l-4.567-4.567v-.063c-1.427 1.684-2.725 3.02-3.761 3.959Zm-4.836-30.627 4.97 7.388 4.97-7.388h-9.94Zm11.552 15.716-2.955-3.627c2.373-2.552 7.496-8.247 9-10.611-.806 3.089-2.552 8.06-6.045 14.238Zm-4.835 6.582L24 30.851l-1.88 1.88-2.015-2.686L24 26.149l4.03 3.896-2.15 2.686Zm-5.24-10.209c-2.283-2.373-7.414-7.952-9.67-11.283 1.208 4.164 3.223 9.537 6.716 15.045.805-1.075 2.238-2.91 2.955-3.762Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNullCmd);
export default __webpack_public_path__ + "static/media/null-cmd.2c65c864.svg";
export { ForwardRef as ReactComponent };